import { useT } from "@/lib/i18n";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
import { PendingForm, type FormField } from "./PendingForm";

export const Licensing = () => {
  const t = useT();
  const fields: FormField[] = [
    { name: "name", label: t.form.name },
    { name: "company", label: t.form.company },
    { name: "email", label: t.form.email, type: "email" },
    {
      name: "project_type",
      label: t.form.projectType,
      type: "select",
      options: [...t.form.projectTypes],
    },
    { name: "message", label: t.form.message, type: "textarea" },
  ];

  return (
    <section
      id="licensing"
      data-testid="licensing-section"
      className="scroll-mt-24 border-y border-if-line bg-if-surface/30"
    >
      <div className="mx-auto grid max-w-7xl gap-16 px-6 py-24 md:grid-cols-2 md:px-12 md:py-32 lg:gap-24 xl:px-24">
        <div>
          <SectionHeading
            index={t.licensing.index}
            eyebrow={t.licensing.eyebrow}
            title={t.licensing.title}
            testId="licensing-heading"
          />
          <Reveal delay={0.1}>
            <p className="max-w-md text-base font-light leading-relaxed text-if-dim">
              {t.licensing.intro}
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <PendingForm
            testId="licensing-form"
            endpoint="/forms/licensing"
            fields={fields}
            submitLabel={t.form.submit}
            active
          />
        </Reveal>
      </div>
    </section>
  );
};
